import type { ThemeDefinition } from 'vuetify';

const light: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#f0f4f5',
    'on-surface': '#363636',
    primary: '#361881',
    'primary-light': '#e4d2f7',
    'primary-lighter': '#f6f2fa',
    'primary-lightest': '#e7e1f0',
    secondary: '#f3584e',
    'secondary-light': '#FFF1F0',
    yellow: '#F3BC14',
    green: '#22D2A8',
    success: '#4caf50',
    info: '#3498ff',
    'info-lighten-1': '#f0f9ff',
    warning: '#ffb300',
    error: '#df2026',
    test: '#EADDCA'
  }
};

const dark: ThemeDefinition = {
  dark: true,
  colors: {}
};

export default { light, dark };
